<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="67.786" height="79.383" viewBox="0 0 67.786 79.383">
		<g id="" data-name="Gruppe 15735" transform="translate(-15713.982 17046)">
			<g id="" transform="translate(15714.482 -17044.5)">
				<path
					id=""
					d="M65.286,70.085a5.8,5.8,0,0,1-5.8,5.8H7.3a5.8,5.8,0,0,1-5.8-5.8V6.3A5.8,5.8,0,0,1,7.3.5H44.991l20.3,20.3Z"
					fill="none"
					:stroke="color"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="4"
				/>
				<g id="" data-name="Gruppe 15733" transform="translate(14.518 24.505)">
					<g id="" data-name="Gruppe 15734" transform="translate(1.094 1.093)">
						<circle
							id=""
							data-name="Ellipse 168"
							cx="4.774"
							cy="4.774"
							r="4.774"
							transform="translate(0 21.097)"
							fill="none"
							:stroke="color"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="4"
						/>
						<circle
							id=""
							data-name="Ellipse 169"
							cx="4.774"
							cy="4.774"
							r="4.774"
							transform="translate(21.485 15.129)"
							fill="none"
							:stroke="color"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="4"
						/>
						<path
							id=""
							data-name="Pfad 9118"
							d="M25.985,20.4V1.687a1.144,1.144,0,0,0-.127-.525,1.168,1.168,0,0,0-.344-.418,1.22,1.22,0,0,0-.494-.222,1.178,1.178,0,0,0-.54.019l-19.1,5.3A1.2,1.2,0,0,0,4.5,6.987V26.371"
							transform="translate(5.049 -0.5)"
							fill="none"
							:stroke="color"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="4"
						/>
						<line
							id=""
							data-name="Linie 202"
							y1="5.968"
							x2="21.485"
							transform="translate(9.549 6.774)"
							fill="none"
							:stroke="color"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="4"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'AudioIcon',
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
};
</script>
